import { createContext, useContext } from 'react';

import {
  TAppConfig,
  TAppConfigProviderProps,
} from '@/shared/features/app-config/context/app-config-context.types';

const AppConfigContext = createContext<TAppConfig | null>(null);

export const AppConfigProvider = ({
  value,
  children,
}: TAppConfigProviderProps) => (
  <AppConfigContext.Provider value={value}>
    {children}
  </AppConfigContext.Provider>
);

export const useAppConfig = (): TAppConfig => {
  const config = useContext(AppConfigContext);

  if (!config) {
    throw new Error('useAppConfig must be used within an AppConfigProvider');
  }

  return config;
};
